export default "__VITE_ASSET__BkSqU3VO__"